import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "rewards-service";

export default {
    getCurrencies() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/rewards/merchant/currencies", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSearchCategories() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/rewards/merchant/categories", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCategories() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/rewards/merchant/categories/list", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getRewardsOld(page = 1) {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/rewards/merchant/all/" + page, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getRewards(page = 1) {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/v2/rewards/merchant/all/" + page, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getRewardOptions() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/v2/rewards/merchant/options", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    createReward(reward) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/v2/rewards/merchant/create", reward, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(status);
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    // TODO: Remove after deploying new my rewards tab
    createRewardOld(reward) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/rewards/merchant/create", reward, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(status);
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateReward(rewardUuid, reward) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v2/rewards/merchant/update/" + rewardUuid,
                reward,
                { Authorization: auth.getToken() }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateRewardOld(rewardUuid, reward) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/rewards/merchant/update/" + rewardUuid,
                reward,
                { Authorization: auth.getToken() }
            )
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    search(param, page = 1) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v2/rewards/merchant/search/" + page,
                param,
                { Authorization: auth.getToken() }
            )
                .then(response => {
                    //console.log(param);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    searchOld(param, page = 1) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/rewards/merchant/search/" + page,
                param,
                { Authorization: auth.getToken() }
            )
                .then(response => {
                    //console.log(param);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    visibility(param, uuid) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/rewards/merchant/visibility/update/" +
                    uuid,
                param,
                { Authorization: auth.getToken() }
            )
                .then(response => {
                    //console.log(param);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    delete(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(BASE_SERVICE_URL + "/rewards/merchant/delete/" + uuid, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    multipleDelete(uuids) {
        return new Promise((resolve, reject) => {
            api.multipleDelete(
                BASE_SERVICE_URL + "/rewards/merchant/multiple/delete",
                {
                    rewards: uuids
                },
                {
                    Authorization: auth.getToken(),
                    "Content-Type": "application/json"
                }
            )
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getECodes(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/rewards/merchant/instant-grat/redeem-codes/" +
                    param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    viewReward(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/v2/rewards/merchant/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    viewRewardOld(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/rewards/merchant/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getRewardsList() {
        return new Promise((resolve, reject) => {
            api.get(`${BASE_SERVICE_URL}/rewards/merchant/options/for-survey`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getCodes(parameters) {
        return new Promise((resolve, reject) => {
            api.post(
                `${BASE_SERVICE_URL}/rewards/merchant/instant-grat/redeem-codes/${parameters.page}`,
                parameters.payload,
                auth.getHeader()
            ).then(response => {
                return resolve(response);
            }).catch((status, error) => {
                reject(status, error);
            });
        });
    }
};
